import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Experaince from "./components/Experiance/Experaince";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ProjectForm from "./components/ADMIN/Newproject";
// import HandleProjects from "./components/ADMIN/HandleProjects";
import { ImFileEmpty } from "react-icons/im";
import CertificateGallery from "./components/CertificateGallery/CertificateGallery";
import GlassLogin from "./components/AdminLogin/GlassLogin";
import AchivementAdder from "./components/ADMIN/AchivementAdder";
import { HelmetProvider } from "react-helmet-async";
import { ChatBot } from "./components/ChatBot/ChatBot";

function App() {
  const [load, upadateLoad] = useState(true);
  const [Particales, setParticales] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
      const timer2 = setTimeout(() => {
      setParticales(true);
    }, 120);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
    <Router>
      <Preloader load={load} />
      <div  className={`App ${!load ? "page-animate-in" : ""} fade-in-wrapper ${!Particales ? "wait" : "visible"}`} id={load ? "no-scroll" : "scroll"} >
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/Experaince" element={<Experaince />} />
          <Route path="/Certificates" element={<CertificateGallery />} />
          <Route path="/admin" element={<GlassLogin/>}/>
          <Route path="/admin/addprject" element={<ProjectForm/>}/>
          {/* <Route path="/admin/handleproject" element={<HandleProjects/>}/> */}
          <Route path="/admin/addAchivement" element={<AchivementAdder/>}/>
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
    <ChatBot/>
    </HelmetProvider>
  );
}

export default App;
